import SvgIcon from '@mui/material/SvgIcon'

export const CryptoGeneric = (props) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <g clipPath="url(#clip0_7664_701)">
      <path
        d="M8 16C3.5815 16 0 12.4185 0 8C0 3.5815 3.5815 0 8 0C12.4185 0 16 3.5815 16 8C16 12.4185 12.4185 16 8 16ZM10.501 4.9275L10.906 3.307L9.608 2.984L9.2865 4.2715C9.07488 4.20025 8.85784 4.14624 8.6375 4.11L8.9595 2.8225L7.6615 2.5L7.2565 4.1205C5.765 4.3915 4.502 5.489 4.1165 7.032C3.731 8.575 4.3295 10.135 5.5185 11.072L5.1135 12.693L6.4115 13.016L6.733 11.7285C6.94462 11.7998 7.16166 11.8538 7.382 11.89L7.06 13.1775L8.358 13.5L8.763 11.8795C9.28749 11.7854 9.7878 11.5872 10.2344 11.2965C10.6809 11.0058 11.0647 10.6285 11.363 10.187L9.9395 9.833C9.61077 10.1652 9.20108 10.4058 8.7509 10.5312C8.30071 10.6566 7.82561 10.6624 7.3725 10.548C5.9395 10.192 5.0625 8.762 5.414 7.3545C5.7655 5.947 7.2135 5.095 8.647 5.4515C9.10061 5.56236 9.51736 5.78989 9.85591 6.11151C10.1945 6.43313 10.443 6.83767 10.577 7.285L12 7.639C11.9445 7.10968 11.7832 6.59691 11.5257 6.13113C11.2682 5.66534 10.9197 5.25604 10.501 4.9275Z"
        fill="#D2D7DF"
      />
    </g>
    <defs>
      <clipPath id="clip0_7664_701">
        <rect width="16" height="16" rx="8" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)

export default CryptoGeneric
